/* eslint-disable no-param-reassign */
import type { SeoData } from 'src/common/types/api/v4/rutter/v1/search/seo';

/**
 * Remove `copy.seo_text` out from the response object as it is not used currently.
 * We do not want to wipe it out completely on rutter side as we possibly going to
 * add it back in some form in the future.
 */
const removeSeoText = (data: SeoData = {}): SeoData => {
  if (data.copy?.seo_text) {
    delete data.copy.seo_text;
  }
  return data;
};

export default removeSeoText;
